module.exports = __webpack_public_path__ + "img/amaris.a774e654.svg";